import React from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HiXCircle } from "react-icons/hi";
import { CustomButton } from "../components/atoms/CustomButton";

const StripeConnectError: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="stripe-connect-error">
      <Helmet>
        <title>{t("paymentModule.stripeConnectError.pageTitle")}</title>
      </Helmet>

      <div className="container mx-auto py-6">
        <div className="mx-auto max-w-lg rounded-lg border border-gray-200 bg-white p-6">
          <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-full bg-red-100">
            <HiXCircle className="h-6 w-6 text-red-600" />
          </div>

          <h1 className="text-xl font-semibold text-gray-900">
            {t("paymentModule.stripeConnectError.title")}
          </h1>

          <p className="mt-0.5 text-sm text-gray-500">
            {t("paymentModule.stripeConnectError.description")}
          </p>

          <div className="mt-4 rounded-lg border border-amber-200 bg-amber-50 p-3">
            <h2 className="text-sm font-medium text-amber-800">
              {t("paymentModule.stripeConnectError.commonReasons")}
            </h2>
            <ul className="mt-1.5 list-inside list-disc space-y-1 text-xs text-amber-700">
              <li>{t("paymentModule.stripeConnectError.reason1")}</li>
              <li>{t("paymentModule.stripeConnectError.reason2")}</li>
              <li>{t("paymentModule.stripeConnectError.reason3")}</li>
              <li>{t("paymentModule.stripeConnectError.reason4")}</li>
            </ul>
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-3">
            <CustomButton
              title={t("paymentModule.stripeConnectError.backButton")}
              onClick={() => navigate("/control-panel/payment-module")}
              variant="primary"
            />
            <span className="text-xs text-gray-500">
              {t("paymentModule.stripeConnectError.supportText")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StripeConnectError;
